import axiosServices from './request';

const combinedMarketing = axiosServices('combinedMarketing');

export default {
  /**全部会员活动 */
  listAllActivity4Wechat: combinedMarketing('post', 'activity/listAllActivity4Wechat'),
  /**会员专区列表 */
  listActivityResource4Wechat: combinedMarketing('post', 'activity/listActivityResource4Wechat'),
  /**会员目录列表 */
  listActivityCatalog4Wechat: combinedMarketing('get', 'activity/listActivityCatalog4Wechat'),
  /**用户会员信息 */
  getUserActivityInfo: combinedMarketing('get', 'activity/getUserActivityInfo'),
  /**用户会员订单列表 */
  listUserMemberOrder: combinedMarketing('get', 'activity/listUserMemberOrder'),
  /**添加会员浏览记录 */
  addBrowseRecord: combinedMarketing('post', 'activity/addBrowseRecord'),
  /**记录资源观看时长 */
  addWatchTimes: combinedMarketing('post', 'activity/addWatchTimes'),
  /**用户是否处于会员期 */
  getUserMemberState: combinedMarketing('get', 'activity/getUserMemberState'),
  /**客户端获取会员活动配置  */
  getByActivityId4Wechat: combinedMarketing('get', 'activityChoice/getByActivityId4Wechat'),
  /**客户端获取精选 */
  getInfoAndListById4Wechat: combinedMarketing('get', 'activityChoice/getInfoAndListById4Wechat'),
  /**wx-banner-客户端获取列表 */
  getActivityList4Wechat: combinedMarketing('get', 'activityBanner/getActivityList4Wechat'),
  /**wx-guide-客户端获取列表 */
  getGuideList4Wechat: combinedMarketing('get', 'activityGuide/getGuideList4Wechat'),
  /** 支付完成获取推荐会员包 */
  getRecommendActivityAfterPay: combinedMarketing('get', 'activity/getRecommendActivityAfterPay'),
  /** 根据学年推荐会员包*/
  getRecommendActivityByYear: combinedMarketing('get', 'activity/getRecommendActivityByYear'),
  /** 获取用户购买会员包数量 */
  getUserBuyCount: combinedMarketing('get', 'activity/getUserBuyCount'),
  /** 获取会员应用详情 */
  listPageResource4Pcloud: combinedMarketing('post', 'activity/listPageResource4Pcloud')
};
